module.exports = __webpack_public_path__ + "img/arrow_right.1307e7fb.svg";